import React, { useState } from 'react';
import { X } from 'lucide-react';

const TEAL = '#4DB6AC';

export const GroupRegisterSheet = ({ seatsLeft, busy, onCancel, onSubmit }) => {
  const [size, setSize] = useState('1');
  const [namesText, setNamesText] = useState('');
  const [consent, setConsent] = useState(false);
  const [error, setError] = useState('');
  const names = namesText.split('\n').map(n => n.trim()).filter(Boolean);

  const submit = () => {
    const n = Number(size);
    if (!Number.isInteger(n) || n < 1) { setError('Enter a whole number of at least 1.'); return; }
    if (seatsLeft != null && n > seatsLeft) { setError(`Only ${seatsLeft} seats left.`); return; }
    if (names.some(x => x.length > 40)) { setError('Each first name can be at most 40 characters.'); return; }
    if (names.length > n) { setError(`You entered ${names.length} names but the group size is ${n}.`); return; }
    if (names.length && !consent) { setError('Please tick the permission box to share these names.'); return; }
    setError('');
    onSubmit({ group_size: n, ...(names.length ? { participant_names: names, consent: true } : {}) });
  };

  return (
    <div data-testid="group-register-sheet" onClick={onCancel} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)', zIndex: 300, display: 'flex', alignItems: 'flex-end', justifyContent: 'center' }}>
      <div onClick={e => e.stopPropagation()} style={{ background: '#fff', borderRadius: '16px 16px 0 0', width: '100%', maxWidth: 480, padding: 18 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
          <h3 style={{ margin: 0, fontSize: 16, fontWeight: 700 }}>Register your group</h3>
          <button data-testid="group-register-close" onClick={onCancel} style={{ background: 'none', border: 'none', cursor: 'pointer' }}><X size={18} /></button>
        </div>
        <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: '#374151', marginBottom: 4 }}>Total number of people coming (include yourself if you are attending)</label>
        <input data-testid="group-size-input" type="number" min={1} max={seatsLeft ?? undefined} value={size} onChange={e => setSize(e.target.value)}
          style={{ width: '100%', padding: 10, borderRadius: 8, border: '1.5px solid #E5E7EB', fontSize: 14, boxSizing: 'border-box' }} />
        {seatsLeft != null && <div style={{ fontSize: 11, color: '#6B7280', marginTop: 3 }}>{seatsLeft} seats left</div>}
        <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: '#374151', margin: '12px 0 4px' }}>First names (optional, one per line)</label>
        <textarea data-testid="group-names-input" rows={4} value={namesText} onChange={e => setNamesText(e.target.value)}
          style={{ width: '100%', padding: 10, borderRadius: 8, border: '1.5px solid #E5E7EB', fontSize: 14, boxSizing: 'border-box' }} />
        <div style={{ fontSize: 11, color: '#6B7280', marginTop: 3 }}>Only you and the SocialStar admins can see these names.</div>
        {names.length > 0 && (
          <label style={{ display: 'flex', gap: 8, alignItems: 'flex-start', fontSize: 12, color: '#374151', marginTop: 10 }}>
            <input data-testid="group-consent-checkbox" type="checkbox" checked={consent} onChange={e => setConsent(e.target.checked)} />
            I have permission from these people to share their first names
          </label>
        )}
        {error && <div data-testid="group-register-error" style={{ fontSize: 12, color: '#B91C1C', marginTop: 8 }}>{error}</div>}
        <button data-testid="group-register-submit" onClick={submit} disabled={busy}
          style={{ width: '100%', marginTop: 14, padding: 12, borderRadius: 10, border: 'none', background: TEAL, color: '#fff', fontWeight: 700, fontSize: 14, cursor: busy ? 'wait' : 'pointer' }}>
          {busy ? 'Registering...' : 'Register group'}
        </button>
      </div>
    </div>
  );
};

export default GroupRegisterSheet;
